<template>
  <app-layout>
    <span slot="toolbar-title">{{ $t('nav.activities') }}</span>

    <q-toolbar inverted slot="header">
      <q-btn flat round dense icon="chevron_left" @click="prevDay" />
      <q-toolbar-title class="absolute-center">
        {{ curDateStr }}
      </q-toolbar-title>
      <q-btn flat v-if="!isToday" :label="$t('activity_list.today')" class="q-ml-auto" @click="today" />
      <q-btn flat round dense icon="chevron_right" :class="{ 'q-ml-auto': isToday }" @click="nextDay" />
    </q-toolbar>

    <q-page padding class="column">
      <activity-list-item
        v-for="activity in activities"
        :key="activity.id"
        :activity="activity"
        :schema="schema"
      />

      <div v-if="!activities.length" class="row col justify-center items-center">
        <h4>{{ $t('activity_list.no_activities') }}</h4>
      </div>
    </q-page>
  </app-layout>
</template>

<script>
import { date } from 'quasar'
import ActivityListItem from './ActivityListItem'

export default {
  components: { ActivityListItem },
  computed: {
    curDate () {
      return this.$store.state.curDate
    },
    activities () {
      return this.$store.state.activities.activities.data.filter(activity =>
        activity.attributes &&
        activity.attributes.start_date === date.formatDate(this.curDate, 'YYYY-MM-DD'))
    },
    curDateStr () {
      if (this.isToday) {
        return this.$t('activity_list.today')
      } else {
        return date.formatDate(this.curDate, 'D.M.YYYY')
      }
    },
    isToday () {
      return date.isSameDate(this.curDate, new Date(), 'day')
    },
    schema () {
      return this.$store.state.schema.schema.activities.attributes
    },
    activityParams () {
      return { ownerId: this.$store.state.auth.userId, curDate: this.curDate }
    }
  },
  watch: {
    schema (sch) {
      const id = sch.event_status.picklist_id
      this.$store.dispatch('getPicklistValues', { id: id, locale: this.$i18n.locale })
    }
  },
  methods: {
    nextDay () {
      const newDate = date.addToDate(this.curDate, { days: 1 })
      this.$store.dispatch('setCurDate', newDate)
      this.$store.dispatch('getActivities', this.activityParams)
    },
    prevDay () {
      const newDate = date.subtractFromDate(this.curDate, { days: 1 })
      this.$store.dispatch('setCurDate', newDate)
      this.$store.dispatch('getActivities', this.activityParams)
    },
    today () {
      const newDate = new Date()
      this.$store.dispatch('setCurDate', newDate)
      this.$store.dispatch('getActivities', this.activityParams)
    }
  },
  created () {
    this.$store.dispatch('getActivities', this.activityParams)
    this.$store.dispatch('getSchema', { mod: 'activities', locale: this.$i18n.locale })
  },
  meta () {
    // Quasar meta plugin sets document title
    return {
      title: this.$t('nav.activities')
    }
  }
}
</script>
